<template>
  <div id="RadioOption">
    <div class="topic_title">{{listData.order}}.( {{typetext}} ){{listData.questionTitle}}</div>
    <div class="img_url" v-if="img_url">
      <img :src="img_url" />
    </div>
    <div class="topic_box">
      <p :key="index" class="option" v-for="(item, index) in listData.questionSelect">
        <el-radio :label="item.value" @change="getVal" v-model="radio">{{item.lable}}</el-radio>
      </p>
    </div>
    <div class="el-Parsing" v-if="showStatus === true">
      <div class="eye_box" v-if="!is_mode">
        <div class="eye_btn" @click="contrast">
          查看答案
        </div>
      </div>
      <div class="eye_box" v-if="is_mode">
        <div class="eye_btn" @click="upBank">
          收起答案
        </div>
      </div>

      <div class="title" v-if="is_mode">
        <div class="title_item">
          参考答案：
          <span class="blue">{{bankdata.questionAnswer}}</span>
        </div>
        <div class="title_item">
          你的答案：
          <span class="red">{{bankdata.select}}</span>
        </div>
      </div>
      <template v-if="is_mode" >
      <div class="content" v-if="bankdata.questionDescribe">答案解析：{{bankdata.questionDescribe}}</div>
      <div class="content" v-else>答案解析：解析正在更新中...</div>
      </template>
    </div>


  </div>
</template>
<script>
module.exports = {
  name: 'radio-option',
  props: ['bankdata', 'typetext','showStatus'],
  data () {
    return {
      listData: '',
      radio: '',
      img_url: '',
      is_mode: false
    }
  },
  computed: {},

  created () {
    this.initData()
  },
  watch: {
    bankdata () {
      this.is_mode=false
      this.radio = ""
      this.initData()
    }
  },
  methods: {
    contrast(){
       this.is_mode = !this.is_mode
    },
    upBank(){
      this.is_mode = !this.is_mode
    },
    getVal () {
      console.log(this.radio)
      let obj = {
        examinationItemId: this.listData.examinationItemId,
        select: this.radio
      }
      this.$emit('getchildval', obj)
    },
    initData () {
      console.log('选择')
      console.log(this.bankdata, 4444)
      let arr = this.bankdata.questionSelect
      if (this.bankdata.img) {
        this.img_url = sessionStorage.getItem("base_url") + this.bankdata.img
      } else {
        this.img_url = ""
      }
      if (!(arr instanceof Array)) {
        console.log(arr, 88888)
        arr = arr.split('###')
        let obj = []
        for (let i = 0; i < arr.length; i++) {
          obj[i] = {}
          obj[i].lable = arr[i]
          obj[i].value = arr[i].substring(0, 1)
        }
        this.bankdata.questionSelect = obj
      }
      this.listData = this.bankdata
      if (this.listData.select) {
        this.radio = this.listData.select
      }
    }
  }
}
</script>

<style scoped>
.eye_btn{
  margin:10px;
  cursor: pointer;
}
.title {
  display: flex;
  font-size: 1rem;
}
.title_item {
  display: inline-flex;
  align-items: center;
}
.content {
  color: #222;
  font-size: 0.875rem;
  line-height: 1.375rem;
  margin: 1.25rem 0;
}
</style>